<ng-container *ngIf="viewModel$ | async as viewModel">
  <mat-card appearance="outlined" [class.mat-elevation-z0]="true">
    <mat-card-content fxLayout="column">

      <!-- actions bar -->
      <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="16px" fxLayout.lt-md="column">
        <form [formGroup]="filtersForm" novalidate>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start start" fxLayoutGap.lt-md="4px" class="actions-bar">
            <h2>Add Stores</h2>
            <mat-form-field appearance="outline" class="mat-form-field-no-padding">
              <mat-icon matPrefix>search</mat-icon>
              <mat-label>Search</mat-label>
              <input matInput formControlName="search" type="text" (input)="onSearch($event)" placeholder="Search"
                #searchInput />
              <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value"
                (click)="clearSearch()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </form>
         <button mat-icon-button (click)="closeDialog()" aria-label="Close">
              <mat-icon>close</mat-icon>
            </button>
      </div>

      <div class="grid-container">

        <table *ngIf="viewModel.stores.length" mat-table [dataSource]="viewModel.stores" matSort
          (matSortChange)="onSort($event)" matSortDisableClear [matSortStart]="'desc'" class="mat-elevation-z8">
          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle(viewModel.stores) : null"
                [checked]="hasSelectableRows(viewModel.stores) && isAllSelected(viewModel.stores)"
                [indeterminate]="hasSelectableRows(viewModel.stores) && isSomeSelected(viewModel.stores)" [disabled]="!hasSelectableRows(viewModel.stores)">
              </mat-checkbox>
            </th>
            <td class="no-ellipsis" mat-cell *matCellDef="let row">
              <ng-container *ngIf="!row.IsAssociatedToEvent; else associatedStore">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </ng-container>
              <ng-template #associatedStore>
              </ng-template>
            </td>
          </ng-container>

          <!-- StoreName Column -->
          <ng-container matColumnDef="StoreName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name"
              [resizeColumn]="true">
              Name
            </th>
            <td mat-cell *matCellDef="let record"> {{ record.Detail.StoreName }}</td>
          </ng-container>

          <!-- ClientKey Column -->
          <ng-container matColumnDef="ClientKey">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ClientKey"
              [resizeColumn]="true">
              Client Key
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Detail.ClientKey }}</td>
          </ng-container>

          <!-- Address1 Column -->
          <ng-container matColumnDef="Address1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Address1"
              [resizeColumn]="true">
              Address1
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Detail.Address1 }}</td>
          </ng-container>

          <!-- Address2 Column -->
          <ng-container matColumnDef="Address2">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Address2"
              [resizeColumn]="true">
              Address2
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Detail.Address2 }}</td>
          </ng-container>

          <!-- City Column -->
          <ng-container matColumnDef="City">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by City"
              [resizeColumn]="true">
              City
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Detail.City }}</td>
          </ng-container>

          <!-- State Column -->
          <ng-container matColumnDef="State">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by State"
              [resizeColumn]="true">
              State
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Detail.State }}</td>
          </ng-container>

          <!-- Country Column -->
          <!-- <ng-container matColumnDef="Country">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Country" [resizeColumn]="true">
            Country
          </th>
          <td mat-cell *matCellDef="let record">{{ record.Country }}</td>
        </ng-container> -->

          <!-- State Column -->
          <ng-container matColumnDef="PostalCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by PostalCode"
              [resizeColumn]="true">
              PostalCode
            </th>
            <td mat-cell *matCellDef="let record">{{ record.Detail.PostalCode }}</td>
          </ng-container>

          <!-- Version Column -->
          <ng-container matColumnDef="Version">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
              Version
            </th>
            <td mat-cell *matCellDef="let record"> {{ record.VersionName }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.disabled-row]="row.IsAssociatedToEvent"></tr>
        </table>

        <table *ngIf="!viewModel.stores.length">
          <tr>
            <td class="no-records" [attr.colspan]="displayedColumns.length">
              <h2>No Records Found</h2>
            </td>
          </tr>
        </table>
      </div>
      <!-- pager -->
      <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.page.pageSize"
        [pageSizeOptions]="[5, 10, 20, 50, 100,500]" (page)="onPage($event)" *ngIf="viewModel.stores.length"
        showFirstLastButtons [pageIndex]="viewModel.page.pageIndex">
      </mat-paginator>
    </mat-card-content>

    <mat-card-actions fxLayout="row" fxLayoutAlign="space-between" gdAlignRows="end" *ngIf="viewModel.stores.length">
      <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
        <button mat-stroked-button type="button" (click)="closeDialog()">
          Cancel
        </button>
        <button mat-raised-button type="button" color="accent" (click)="associateStore()"
          [disabled]="!selection.selected.length">
          Select
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</ng-container>
